import { render, staticRenderFns } from "./TheAppSwitcher.vue?vue&type=template&id=4a7d0105"
import script from "./TheAppSwitcher.vue?vue&type=script&lang=js"
export * from "./TheAppSwitcher.vue?vue&type=script&lang=js"
import style0 from "./TheAppSwitcher.vue?vue&type=style&index=0&id=4a7d0105&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports